<script setup lang="ts">
import { RouterLink, useRoute } from 'vue-router'

const route = useRoute()
</script>

<template>
	<footer class="bg-gray-800 border-t border-gray-700 py-10">
		<div class="mx-auto max-w-7xl px-6 lg:px-8">
			<div
				class="flex flex-col sm:flex-row items-center justify-between gap-6 text-center sm:text-left"
			>
				<div class="flex flex-col sm:flex-row items-center gap-4">
					<img
						src="@/assets/logo-png-eb.png"
						alt="Enlacebooking"
						class="h-8 w-auto brightness-0 invert opacity-90"
					/>
					<div class="flex flex-col gap-1">
						<p class="text-sm text-gray-200">
							© {{ new Date().getFullYear() }} Enlaceforte S.A. de C.V. · Todos los
							derechos reservados
						</p>
						<p class="text-xs text-gray-300">
							Av. Prol. Francisco I. Madero Oriente 4080-19, Col. Fierro, Monterrey,
							N.L. 64590, México
						</p>
					</div>
				</div>
				<div class="flex items-center gap-5 flex-wrap justify-center">
					<RouterLink
						v-if="route.path !== '/legal/privacy'"
						to="/legal/privacy"
						class="text-sm font-medium text-white hover:text-blue-300 underline underline-offset-4 transition-colors whitespace-nowrap"
					>
						Aviso de Privacidad
					</RouterLink>
					<span v-if="route.path !== '/legal/privacy' && route.path !== '/legal/terms-of-service'" class="text-gray-500 text-sm">·</span>
					<RouterLink
						v-if="route.path !== '/legal/terms-of-service'"
						to="/legal/terms-of-service"
						class="text-sm font-medium text-white hover:text-blue-300 underline underline-offset-4 transition-colors whitespace-nowrap"
					>
						Términos y Condiciones
					</RouterLink>
				</div>
			</div>
		</div>
	</footer>
</template>
